import React, { useEffect, useState } from "react";
import { Mixpanel } from "../../../config/Mixpanel";
import { ClipLoader, PulseLoader } from "react-spinners";
import {
  curateUsersCourse,
  fetchUUID,
  getUserOlduuid,
  checkCourseUnlocked,
} from "../../../redux/actions/onBoarding";
import { useDispatch, useSelector } from "react-redux";
import AchievementSection from "./AchievementSection";
import Constants from "../../../common/constants";

export const successStories = [
  {
    id: 1,
    name: "Kishore V",
    description:
      "Having completed my MBA in Business Administration, my inclination towards the financial sector led me to a position in a cooperative bank. Seeking a transition to the tech field, a mutual friend recommended LearnTube as the ideal platform for upskilling and acquiring tech skills.\nThe courses, meticulously structured and easily comprehensible, facilitated my learning journey. Within a span of 3 weeks, I successfully completed around 7-8 micro-skills in UI/UX Design. The depth of the course videos and the inclusion of quizzes significantly enhanced my understanding and retention of the material.\nLearnTube's experienced mentors, who are domain experts, conducted weekly sessions, providing me with the opportunity to address any doubts or queries I encountered. I wholeheartedly endorse LearnTube to anyone seeking to upskill and navigate a career transition!",
    videoUrl: "https://youtu.be/vVUpuvHWaz8",
    from: "From Finance",
    to: "Tech in 3 Weeks",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146.png?updatedAt=1706083679906",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(9).png?updatedAt=1706100044811",
  },
  {
    id: 2,
    name: "Fahmida",
    description:
      "My substantial academic development, spanning from the initial year to the ultimate year, owes a considerable portion of its success to the remarkable support I received in upskilling through a platform I stumbled upon on Instagram, known as LearnTube. Delving into their courses, I made the strategic decision to specialize in digital marketing.\nThe LearnTube experience went beyond merely imparting new skills and securing verified certifications; it became a transformative force in bolstering my resume and offering invaluable interview preparation assistance. The comprehensive nature of the courses allowed me to navigate the intricacies of digital marketing with confidence and competence.",
    videoUrl: "https://youtu.be/JfGX8-Z55EE",
    from: "Fresher",
    to: "A Digital Marketing Specialist",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(1).png?updatedAt=1706083773178",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205147.png?updatedAt=1706100149035",
  },
  {
    id: 3,
    name: "SHUBHAM GAIKWAD",
    description:
      "As a Computer Engineering student, my aspiration was to explore the realm of Web Development. While I possessed some preliminary knowledge, delving into the courses offered by LearnTube unveiled the vastness of the field. Through LearnTube, I not only obtained certifications in HTML, Java, and CSS but also applied these acquired skills in a practical project. The experienced mentors at LearnTube played a pivotal role in providing guidance, imparting real-world knowledge that transcended the theoretical realm.\nThe exceptional team at LearnTube was consistently supportive, readily available whenever I required assistance. This collaborative environment enhanced my learning experience, fostering a sense of confidence and competence in the intricate domain of Web Development. LearnTube not only equipped me with certifications but also facilitated the practical application of skills, bridging the gap between theoretical understanding and real-world implementation.",
    videoUrl: "https://youtu.be/zQbxAQESw8Y",
    from: "Computer Engineer",
    to: "An expert Web Developer",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(2).png?updatedAt=1706083884308",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205148.png?updatedAt=1706100206471",
  },
  {
    id: 4,
    name: "Aftab ahmed",
    description:
      "Despite having a masters in aerospace engineering I was always intrigued by the world of artificial intelligence as well as robotics. That's where LearnTube came in.\n I completed various courses on LearnTube related to AI such as data structures & algorithms, python, machine learning and deep learning. I love the fact that they have content from a whole range of tutors, and you can learn from the ones who best suit you.\nSomething I found very useful was the mentorship program, which ensured that I got valuable advice that sped up my preparation. LearnTube also helped me build valuable projects using cutting-edge technology and make me confident to face interviews, and I'm hopeful that I will get into my dream company.",
    videoUrl: "https://youtu.be/nPFIEpK8NKE",
    from: "Pivot from Aersopace engineering",
    to: "AI",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(3).png?updatedAt=1706083986393",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205149.png?updatedAt=1706100257026",
  },
  {
    id: 5,
    name: "Dinesh",
    description:
      "After my graduation, I was on the lookout for internships and full-time jobs when a friend told me about an app called LearnTube. I signed up and started learning various courses such as Computer Fundamentals and some programming languages. The courses were well structured and the videos explained the concepts in depth, which benefited me a lot in enhancing my skills.\nArmed with stronger and better skillsets, I landed an internship at Candere by Kalyan Jewellers with a great stipend. I kept gaining more skills on LearnTube along with my internship. Once my internship was over, I decided to turn my focus towards getting a full time job.\nI started learning some core skills such as Machine Learning and enhancing my CV and profile, all of which led me to crack an excellent job opportunity at Mirae Asset Capital Markets as a Software Developer, with a significant salary bump and great perks!",
    videoUrl: "https://youtube.com/shorts/WU2okGs-fJE?feature=share",
    from: "Graduate",
    to: "Landing an internship at Kalyan Jewellers ",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(4).png?updatedAt=1706084058078",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205150.png?updatedAt=1706100314081",
  },
  {
    id: 6,
    name: "Darshan Deshmukh",
    description:
      "Enrolling in LearnTube initiated my exploration of various Python courses, with a focus on Modules and Packages. Completing these courses significantly enhanced my understanding of Python and its crucial role in data analytics, vital for my ongoing pursuits in this field.\nAddressing challenges or unclear concepts during the learning process became effortless by consulting the experienced mentors on LearnTube. Their guidance played a key role in fortifying my understanding and strengthening foundational concepts.\nAn exceptional feature of these courses is their cost-free nature, ensuring access to valuable learning resources without financial burden. This not only fosters a conducive learning environment but also democratizes education, providing high-quality Python courses to learners without monetary constraints. LearnTube has truly become an invaluable asset in my journey to expertise in Python and data analytics.",
    videoUrl: "https://youtube.com/shorts/iJxXNE5DsVM?feature=share",
    from: "Novice",
    to: "An Expert Data Analyst",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(5).png?updatedAt=1706084101420",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205151.png?updatedAt=1706100362879",
  },
  {
    id: 7,
    name: "Ribhu",
    description:
      "Being a freelancer, I knew that despite having a Masters degree in Mass Communication, I needed to keep updating my skills to have a competitive edge in my career. I started learning Search Engine Marketing on LearnTube to understand the field of SEM in depth and Marketing as a whole and enhance my knowledge.\nThe best part about LearnTube is that they support you through every step of your upskilling journey and help you analyze your progress from start to end and provide insightful tips to boost your learning curve.\nAfter finishing the SEM courses on LearnTube, I have a much deeper understanding about the subject. I am confident in demonstrating my SEM skills to my clients and in the process even gained new clients!",
    videoUrl: "https://youtu.be/pKkerknQF5k",
    from: "Passive freelancing",
    to: "Landing countless clients",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(6).png?updatedAt=1706084153970",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205152.png?updatedAt=1706100433715",
  },
  // {
  //     id: 8,
  //     name: 'Rohan Mudhiraj',
  //     description: "As an engineering student, I knew the importance programming had on my career growth, but I couldn't find the right place to start learning. While doing some intensive research I came across this interesting place called LearnTube by CareerNinja.\nI was blown away by the vast number of quality courses they had on various industry-relevant skills in domains like programming, digital marketing, cloud computing and more. I started learning Python and MySQL and it was a very good educational experience.\nAfter completing the courses, I got verified certificates which I flaunted on my resume, and it made my resume much stronger. I also loved the fact that they kept giving micro-quizzes during the course which kept me on my toes and boosted my knowledge.",
  //     videoUrl: 'https://youtube.com/watch?v=p09JbA3FDgQ&feature=share',
  //     from: 'Ordinary engineering student',
  //     to: 'A higly skilled programmer',
  //     thumbNail: 'https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(7).png?updatedAt=1706084200717'
  // },
  {
    id: 9,
    name: "Sree Varsha",
    description:
      "Being a computer science and engineering I was always intrigued by the world of Full stack development . That's where LearnTube came in.\nI completed various courses on LearnTube related to Full Stack Development such as data structures & algorithms, Front end development (HTML, CSS, JS and REACT JS) , Backend (MERN) and much more. I love the fact that they have content from a whole range of tutors, and you can learn from the ones who best suit you.\nSomething I found very useful was the mentorship program, which ensured that I got valuable advice that sped up my preparation. LearnTube also helped me build valuable projects using cutting-edge technology and make me confident to face interviews, and I'm hopeful that I will get into my dream company.",
    videoUrl: "https://youtu.be/3vFEJQarDjg",
    from: "Computer Science Engineer",
    to: "A Full Stack Developer",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(7).png?updatedAt=1706084200717",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205153.png?updatedAt=1706100491936",
  },
  {
    id: 10,
    name: "Rupa Shree",
    description:
      "Earning five LearnTube certifications in a month marked the start of my academic journey. The WhatsApp bot amazed me, enabling seamless learning on the go, even amid travel or work. LearnTube's organized courses, with regular quizzes, fortified my understanding and ensured concept retention, boosting confidence in my PGDM studies.\nLearnTube's versatile approach, integrating the WhatsApp bot, made education flexible. The structured curriculum, with interactive quizzes, vitalized my knowledge for PGDM challenges. LearnTube's commitment to enhancing learning was evident, offering a valuable resource that significantly enriched my academic pursuits.",
    videoUrl: "https://youtu.be/KvygfsHoUUE",
    from: "Went from achieveing 5 Certificates a month",
    to: "Aceing her PGDM studies ",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(8).png?updatedAt=1706084293864",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205154.png?updatedAt=1706100529885",
  },
];

const CourseFreeLoader = () => {
  const [gifLoaded, setGifLoaded] = useState(true);
  const user_name = useSelector((store) => store?.profileDetails?.name);
  const first_name = useSelector((store) => store?.profileDetails?.first_name);
  const email = useSelector((store) => store?.profileDetails?.email);
  const phone_number = useSelector(
    (store) => store?.profileDetails?.["phone-number"],
  );
  const skill_name = useSelector(
    (store) => store?.onBoarding?.selectedSkill?.["skill-name"],
  );
  const dispatch = useDispatch();
  const [isCurating, setIsCurating] = useState(true);

  useEffect(() => {
    Mixpanel.track(
      Constants.Mixpanel.ONBOARDING_PAGE_25_COURSE_PAGE_FREE_LOADER_LOADED,
    );
    setTimeout(() => setGifLoaded(false), 1300);
  }, []);

  useEffect(() => {
    if (user_name && email && phone_number && skill_name) {
      dispatch(
        fetchUUID(
          user_name,
          email,
          phone_number,
          skill_name,
          "course-free-button",
          "onboarding-flow",
          (res) => {
            dispatch(
              curateUsersCourse(
                res?.uuid,
                email,
                user_name,
                skill_name,
                false,
                [],
                phone_number,
                true,
                () => {
                  dispatch(
                    getUserOlduuid(email, (res1) => {
                      // Start long polling after getUserOlduuid resolves
                      if (res1?.uid) {
                        dispatch(
                          checkCourseUnlocked(
                            res1?.uid,
                            [skill_name],
                            (unlockRes) => {
                              window.location.href = `https://personalise.learntube.ai/welcome?email=${email}&skill_name=${skill_name}&utm_source=onboarding-flow&utm_medium=course-free-button`;
                            },
                          ),
                        );
                      }
                    }),
                  );
                },
                (err) => {},
              ),
            );
          },
          (err) => {},
        ),
      );
    }
  }, [dispatch, email, phone_number, skill_name, user_name, first_name]);

  const [time, setTime] = useState({
    minutes: 7,
    seconds: 0,
  });
  const [count, setCount] = useState(0);

  // Countdown timer logic
  useEffect(() => {
    const interval = setInterval(() => {
      setTime((prevTime) => {
        // If both minutes and seconds are 0, reset the timer
        if (prevTime.minutes === 0 && prevTime.seconds === 0) {
          setCount((prevCount) => prevCount + 1);
          return {
            minutes: 5,
            seconds: 0,
          };
        }

        // If seconds are 0 but minutes remain, decrement minutes and set seconds to 59
        if (prevTime.seconds === 0) {
          return {
            minutes: prevTime.minutes - 1,
            seconds: 59,
          };
        }

        // Normal second decrement
        return {
          minutes: prevTime.minutes,
          seconds: prevTime.seconds - 1,
        };
      });
    }, 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex h-screen w-full max-w-[720px] flex-col pb-4  text-white lg:pb-6">
      <div className="mt-6 lg:mt-4">
        <div className="flex items-center justify-center">
          <p className="mr-3 text-2xl">{`${time.minutes
            .toString()
            .padStart(1, "")}:${time.seconds.toString().padStart(2, "0")}`}</p>
          <ClipLoader size={24} color="#7FC241" />
        </div>
        <div className="flex justify-center">
          <p className="text-center text-sm">
            {count === 0
              ? "Finalising Your Course, Assessments & Projects"
              : count === 1
              ? "Oops, finding the best content for you is taking a little longer than expected."
              : `Hang on ${user_name}. We’re almost there!`}
          </p>
          <PulseLoader size={2} color="#fff" className="mt-[11px]" />
        </div>
      </div>
      <div className="-mt-4 flex flex-1 flex-col justify-center lg:my-4">
        <h2 className="mb-1 text-center text-[32px] leading-[37px]">
          {first_name}, Meanwhile Grab A Coffee &{" "}
          <span className="font-bold text-[#00C1FF]">
            Explore Our Learner Stories
          </span>
        </h2>
        <AchievementSection achievements={successStories} />
      </div>
    </div>
  );
};

export default CourseFreeLoader;
